import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
    ITEM: '[data-fragment="OfficialBoardList.item"]'
};

export default class OfficialBoardList extends WebComponent {
    didMount() {
        const hashData = window.location.hash.substring(1);
        const items = [...this.element.querySelectorAll(fragments.ITEM)];
        const navbar = document.getElementById('headerMain');

        items.forEach(function(item) {
            let itemUrl = item.dataset.itemUrl;
            if (hashData == itemUrl) {
                item.classList.add('active');

                navbar.classList.add("sticky");
                navbar.parentElement.classList.add("sticky-bg");
                const navbarHeight = navbar.offsetHeight;
                const anchorOffset = 25;
                let stickyOffset = 0;
                if (navbarHeight > 99) stickyOffset = navbarHeight;

                const y = item.getBoundingClientRect().top + window.scrollY - stickyOffset - anchorOffset;
                window.scroll({
                    top: y,
                    behavior: 'smooth'
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/OfficialBoardList.js